<template>
    <div class="w-full rounded-lg shadow bg-base-100">
        <h5 class="p-4 font-bold rounded-t-lg bg-base-300">JS Validation</h5>
        <div class="w-full p-4">
            <form class="grid needs-validation peer gap-y-4">
                <!-- Account Details -->
                <div class="w-full">
                    <h6 class="text-lg font-semibold">1. Account Details</h6>
                    <hr class="mt-2 mb-4" />
                </div>
                <div class="grid grid-cols-1 gap-6 md:grid-cols-2">
                    <div>
                        <label class="label label-text" for="firstName"
                            >First Name
                        </label>
                        <input
                            id="firstName"
                            type="text"
                            placeholder="John"
                            class="input"
                            required
                        />
                        <span class="error-message"
                            >Please enter your name.</span
                        >
                        <span class="success-message">Looks good!</span>
                    </div>
                    <div>
                        <label class="label label-text" for="lastName"
                            >Last Name</label
                        >
                        <input
                            id="lastName"
                            type="text"
                            placeholder="Doe"
                            class="input"
                            required
                        />
                        <span class="error-message"
                            >Please enter your last name.</span
                        >
                        <span class="success-message">Looks good!</span>
                    </div>
                </div>
                <!-- Email and password -->
                <div class="grid grid-cols-1 gap-6 md:grid-cols-2">
                    <div>
                        <label class="label label-text" for="userEmail"
                            >Email</label
                        >
                        <input
                            id="userEmail"
                            type="email"
                            class="input"
                            placeholder="john@gmail.com"
                            aria-label="john@gmail.com"
                        />
                        <span class="error-message"
                            >Please enter a valid email</span
                        >
                        <span class="success-message">Looks good!</span>
                    </div>
                    <div>
                        <label class="label label-text" for="userPassword"
                            >Password</label
                        >
                        <div class="input-group">
                            <input
                                id="userPassword"
                                type="password"
                                class="input"
                                placeholder="Enter password"
                            />
                            <span class="input-group-text">
                                <button
                                    type="button"
                                    data-toggle-password='{ "target": "#userPassword" }'
                                    class="block"
                                >
                                    <span
                                        class="icon-[tabler--eye] text-base-content/80 password-active:block hidden size-4 flex-shrink-0"
                                    ></span>
                                    <span
                                        class="icon-[tabler--eye-off] text-base-content/80 password-active:hidden block size-4 flex-shrink-0"
                                    ></span>
                                </button>
                            </span>
                        </div>
                        <span class="error-message"
                            >Please enter a valid password</span
                        >
                        <span class="success-message">Looks good!</span>
                    </div>
                </div>
                <!-- Personal Info -->
                <div class="w-full">
                    <h6 class="text-lg font-semibold">2. Personal Info</h6>
                    <hr class="mt-2 mb-4" />
                </div>
                <div class="grid grid-cols-1 gap-6 md:grid-cols-2">
                    <div>
                        <label class="label label-text" for="userProfile"
                            >Profile Pic</label
                        >
                        <input id="userProfile" type="file" class="input" />
                        <span class="error-message"
                            >Please select the file</span
                        >
                        <span class="success-message">Looks good!</span>
                    </div>
                    <div>
                        <label class="label label-text" for="jsPickr"
                            >DOB</label
                        >
                        <input id="jsPickr" type="text" class="input" />
                        <span class="error-message"
                            >Please select your DOB</span
                        >
                        <span class="success-message">Looks good!</span>
                    </div>
                </div>
                <div class="grid grid-cols-1 gap-6 md:grid-cols-2">
                    <div>
                        <label class="label label-text" for="userCountry"
                            >Pick your Country</label
                        >
                        <select
                            class="select"
                            id="userCountry"
                            aria-label="Select Country"
                        >
                            <option value="">Select Country</option>
                            <option value="usa">USA</option>
                            <option value="uk">UK</option>
                            <option value="france">France</option>
                            <option value="australia">Australia</option>
                            <option value="spain">Spain</option>
                        </select>
                        <span class="error-message"
                            >Please select your country</span
                        >
                        <span class="success-message">Looks good!</span>
                    </div>
                    <div>
                        <div class="label label-text">Gender</div>
                        <div class="flex items-center gap-2">
                            <input
                                type="radio"
                                id="male"
                                name="radio-0"
                                class="radio radio-primary"
                            />
                            <label class="text-base label label-text" for="male"
                                >Male</label
                            >
                        </div>
                        <div class="flex items-center gap-2">
                            <input
                                type="radio"
                                id="female"
                                name="radio-0"
                                class="radio radio-primary"
                            />
                            <label
                                class="text-base label label-text"
                                for="female"
                                >Female</label
                            >
                        </div>
                        <span class="error-message"
                            >Please select your Gender</span
                        >
                        <span class="success-message">Looks good!</span>
                    </div>
                </div>
                <div class="w-full">
                    <label class="label label-text" for="userBio">Bio</label>
                    <textarea
                        class="resize-none textarea min-h-20"
                        id="userBio"
                        placeholder="Hello!!!"
                    ></textarea>
                    <span class="error-message">Please write few words</span>
                    <span class="success-message">Looks good!</span>
                </div>
                <div>
                    <div class="flex items-center gap-3">
                        <input
                            type="checkbox"
                            id="userSwitch"
                            class="switch switch-primary"
                        />
                        <label class="text-base label" for="userSwitch"
                            >Send me related emails</label
                        >
                    </div>
                    <span class="error-message"
                        >Please select your preference</span
                    >
                    <span class="success-message">Looks good!</span>
                </div>
                <div>
                    <div class="flex items-center gap-3">
                        <input
                            type="checkbox"
                            class="checkbox checkbox-primary"
                            id="userAgre"
                            required
                        />
                        <label class="text-base label" for="userAgre"
                            >Agree to our terms and conditions</label
                        >
                    </div>
                    <span class="error-message">Please confirm our T&C</span>
                    <span class="success-message">Looks good!</span>
                </div>
                <!-- Submit button -->
                <div class="mt-4">
                    <button
                        type="submit"
                        name="submitButton"
                        class="btn btn-primary"
                    >
                        Submit
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>
